<template>
  <div>
    <!-- 顶部导航栏 -->
    <el-header class="dynamic-header" :class="{ 'solid-bg': isSolid }" @mouseenter.native="handleMouseEnter"
      @mouseleave.native="handleMouseLeave">
      <div class="header-content">
        <!-- 左侧品牌区 -->
        <div class="brand-group">
          <img src="@/assets/logo.png" class="brand-logo">
          <span class="brand-name">深圳健希生物科技有限公司</span>
        </div>

        <!-- 中央导航菜单 -->
        <el-menu 
          mode="horizontal" 
          
          background-color="transparent" 
          :default-active="activeIndex"
          router 
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/Solution">解决方案</el-menu-item>
          <el-menu-item index="/CompanyProducts">公司产品</el-menu-item>
          <el-menu-item index="/about-us">关于我们</el-menu-item>
          
        </el-menu>

        <!-- 右侧联系方式 -->
        <div class="contact-info" >
          <i class="el-icon-phone"></i>
          <span>0755-22370171</span>
        </div>
      </div>
    </el-header>
    <!-- 动态内容区域 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSolid: false,
      activeIndex: this.$route.path, // 初始值设为当前路径
      isHovering: false
    };
  },

  methods: {
    handleMouseEnter() {
      this.isHovering = true;
      this.updateHeaderState();
    },
    handleMouseLeave() {
      this.isHovering = false;
      this.updateHeaderState();
    },
    updateHeaderState() {
      this.isSolid = this.isHovering || window.scrollY > 10;
    }
  },
  watch: {
    // 监听路由变化，同步菜单激活状态
    $route(newVal) {
      this.activeIndex = newVal.path;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.updateHeaderState);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateHeaderState);
  }
};
</script>

<style scoped>
.dynamic-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: transparent !important;
  transition: all 0.3s ease;
  border-bottom: none !important;
}

.solid-bg {
  background: white !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand-group {
  display: flex;
  align-items: center;
}

.brand-logo {
  width: 32px;
  height: 32px;
  margin-right: 12px;
}

.brand-name {
  font-size: 20px;
  font-weight: 500;
  /* color: white; */
  /* transition: color 0.3s; */
}

.solid-bg .brand-name {
  color: #2c3e50;
}

/* 文字颜色控制 */
.light-text {
  color: white !important;
}

.dark-text {
  color: #2c3e50 !important;
}

::v-deep .el-menu-item {
  background: transparent !important;
  font-size: 16px;
  transition: color 0.3s;
}

::v-deep .el-menu-item:hover {
  color: #00f0ff !important;
}

.contact-info {
  display: flex;
  align-items: center;
  font-size: 16px;
  transition: color 0.3s;
}

.el-icon-phone {
  margin-right: 8px;
  font-size: 18px;
}
</style>